/*
 *
 * InitiateRefundModalV2 reducer
 *
 */
import produce from 'immer';
import {
  DEFAULT_ACTION,
  SAVE_VENDORS_RESPONSE,
  ENABLE_LOADER,
  DISABLE_LOADER,
  SAVE_MAXIMUM_REFUND_AMOUNT,
  RESET_MODAL_DATA,
} from './constants';

export const initialState = {
  isLoading: false,
  vendorsStatus: [],
  maximumRefund: undefined,
  disputedAmount: undefined,
};

/* eslint-disable default-case, no-param-reassign */
const initiateRefundModalV2Reducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case ENABLE_LOADER: {
        draft.isLoading = true;
        break;
      }
      case DISABLE_LOADER: {
        draft.isLoading = false;
        break;
      }
      case SAVE_VENDORS_RESPONSE: {
        const { data } = action;
        draft.isLoading = false;
        draft.vendorsStatus = data.map(vendor => vendor.status);
        break;
      }
      case SAVE_MAXIMUM_REFUND_AMOUNT: {
        const { disputedAmount, refundableAmount } = action.data;
        draft.maximumRefund = refundableAmount;
        draft.disputedAmount = disputedAmount;
        break;
      }
      case RESET_MODAL_DATA: {
        draft.maximumRefund = undefined;
        draft.vendorsStatus = [];
        break;
      }
      case DEFAULT_ACTION:
        break;
    }
  });

export default initiateRefundModalV2Reducer;
